(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function cada(lista, fn) { Array.prototype.forEach.call(lista, fn); }

  function initReveals() {
    var items = document.querySelectorAll('.tbl-reveal:not(.tbl-visible)');
    if (!items.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      cada(items, function (el) { el.classList.add('tbl-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('tbl-visible');
        obs.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    cada(items, function (el) { obs.observe(el); });
  }

  function initParallax() {
    var fotos = document.querySelectorAll('[data-tbl-parallax]');
    if (!fotos.length || reduce) return;
    var ticking = false;
    function update() {
      cada(fotos, function (foto) {
        var fuerza = parseFloat(foto.getAttribute('data-tbl-parallax')) || 0;
        if (!fuerza) return;
        var rect = foto.getBoundingClientRect();
        var centro = rect.top + rect.height / 2 - window.innerHeight / 2;
        foto.style.setProperty('--tbl-parallax', (-centro * fuerza / 100).toFixed(1) + 'px');
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });
    update();
  }

  /* Carrusel de la portada */
  function initHero() {
    cada(document.querySelectorAll('[data-tbl-hero]'), function (pista) {
      if (pista.getAttribute('data-tbl-listo') === 'si') return;
      pista.setAttribute('data-tbl-listo', 'si');

      var slides = pista.querySelectorAll('[data-tbl-slide]');
      if (slides.length < 2) return;

      var seccion = pista.closest('.shopify-section') || pista.parentNode;
      var puntos = seccion.querySelectorAll('[data-tbl-punto]');
      var actual = 0;
      var reloj = null;
      var espera = (parseFloat(pista.getAttribute('data-tbl-autoplay')) || 0) * 1000;

      function mostrar(indice) {
        actual = (indice + slides.length) % slides.length;
        cada(slides, function (slide, i) {
          slide.classList.toggle('tbl-activa', i === actual);
        });
        cada(puntos, function (punto, i) {
          punto.setAttribute('aria-current', i === actual ? 'true' : 'false');
        });
      }

      function arrancar() {
        if (!espera || reduce) return;
        parar();
        reloj = window.setInterval(function () { mostrar(actual + 1); }, espera);
      }
      function parar() {
        if (reloj) { window.clearInterval(reloj); reloj = null; }
      }

      cada(puntos, function (punto, i) {
        punto.addEventListener('click', function () {
          mostrar(i);
          arrancar();
        });
      });

      pista.addEventListener('mouseenter', parar);
      pista.addEventListener('mouseleave', arrancar);
      pista.addEventListener('focusin', parar);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { parar(); } else { arrancar(); }
      });

      /* Deslizar con el dedo en móvil */
      var x0 = null;
      pista.addEventListener('touchstart', function (e) {
        x0 = e.changedTouches[0].clientX;
      }, { passive: true });
      pista.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 45) { mostrar(actual + (dx < 0 ? 1 : -1)); arrancar(); }
        x0 = null;
      }, { passive: true });

      mostrar(0);
      arrancar();
    });
  }

  /* Cifras que cuentan al entrar en pantalla */
  function initCifras() {
    var cifras = document.querySelectorAll('[data-tbl-cifra]');
    if (!cifras.length) return;

    function animar(el) {
      var bruto = (el.getAttribute('data-tbl-cifra') || '').replace(',', '.');
      var sufijo = el.getAttribute('data-tbl-sufijo') || '';
      var destino = parseFloat(bruto.replace(/[^0-9.]/g, ''));
      var prefijoTexto = bruto.replace(/[0-9.,]/g, '');
      if (isNaN(destino) || reduce) return;
      var decimales = (bruto.split('.')[1] || '').length;
      var inicio = null;
      var duracion = 1100;
      function paso(t) {
        if (!inicio) inicio = t;
        var avance = Math.min((t - inicio) / duracion, 1);
        var suave = 1 - Math.pow(1 - avance, 3);
        var valor = (destino * suave).toFixed(decimales);
        el.textContent = valor + prefijoTexto + sufijo;
        if (avance < 1) window.requestAnimationFrame(paso);
      }
      el.textContent = '0' + prefijoTexto + sufijo;
      window.requestAnimationFrame(paso);
    }

    if (!('IntersectionObserver' in window) || reduce) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        animar(entry.target);
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.4 });
    cada(cifras, function (el) { obs.observe(el); });
  }

  function initGaleria() {
    cada(document.querySelectorAll('[data-tbl-galeria]'), function (galeria) {
      var principal = galeria.querySelector('[data-tbl-foto-principal]');
      var minis = galeria.querySelectorAll('[data-tbl-mini]');
      if (!principal || !minis.length) return;
      cada(minis, function (mini) {
        mini.addEventListener('click', function () {
          var src = mini.getAttribute('data-src');
          var alt = mini.getAttribute('data-alt') || '';
          if (!src) return;
          principal.style.opacity = '0';
          window.setTimeout(function () {
            principal.setAttribute('src', src);
            principal.setAttribute('alt', alt);
            principal.style.opacity = '1';
          }, 140);
          cada(minis, function (m) { m.setAttribute('aria-current', 'false'); });
          mini.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  function initVariantes() {
    cada(document.querySelectorAll('[data-tbl-producto]'), function (raiz) {
      var datos = raiz.querySelector('[data-tbl-variantes]');
      if (!datos) return;
      var variantes;
      try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
      if (!variantes || !variantes.length) return;

      var grupos = raiz.querySelectorAll('[data-tbl-opcion]');
      var inputId = raiz.querySelector('[data-tbl-variante-id]');
      var precioEl = raiz.querySelector('[data-tbl-precio]');
      var antesEl = raiz.querySelector('[data-tbl-precio-antes]');
      var botonEl = raiz.querySelector('[data-tbl-anadir]');
      var stockEl = raiz.querySelector('[data-tbl-stock]');
      var textoAnadir = botonEl ? botonEl.getAttribute('data-texto') : '';
      var textoAgotado = botonEl ? botonEl.getAttribute('data-texto-agotado') : '';

      function seleccionadas() {
        var vals = [];
        cada(grupos, function (grupo) {
          var activo = grupo.querySelector('[aria-checked="true"]');
          vals.push(activo ? activo.getAttribute('data-valor') : null);
        });
        return vals;
      }

      function aplicar() {
        var vals = seleccionadas();
        var match = variantes.filter(function (v) {
          return vals.every(function (val, i) { return val === null || v.options[i] === val; });
        })[0];
        if (!match) return;
        if (inputId) inputId.value = match.id;
        if (precioEl && match.precio) precioEl.innerHTML = match.precio;
        if (antesEl) {
          if (match.antes) { antesEl.innerHTML = match.antes; antesEl.hidden = false; }
          else { antesEl.hidden = true; }
        }
        if (botonEl) {
          botonEl.disabled = !match.available;
          botonEl.textContent = match.available ? textoAnadir : textoAgotado;
        }
        if (stockEl) {
          stockEl.classList.toggle('tbl-pdp__stock--agotado', !match.available);
          var etiqueta = stockEl.querySelector('span');
          if (etiqueta) {
            etiqueta.textContent = match.available
              ? stockEl.getAttribute('data-disponible')
              : stockEl.getAttribute('data-agotado');
          }
        }
      }

      cada(grupos, function (grupo) {
        cada(grupo.querySelectorAll('[data-valor]'), function (boton) {
          boton.addEventListener('click', function () {
            cada(grupo.querySelectorAll('[data-valor]'), function (b) {
              b.setAttribute('aria-checked', 'false');
            });
            boton.setAttribute('aria-checked', 'true');
            aplicar();
          });
        });
      });
      aplicar();
    });
  }

  function initCantidad() {
    cada(document.querySelectorAll('[data-tbl-cantidad]'), function (caja) {
      var input = caja.querySelector('input');
      if (!input) return;
      cada(caja.querySelectorAll('[data-paso]'), function (boton) {
        boton.addEventListener('click', function () {
          var paso = parseInt(boton.getAttribute('data-paso'), 10) || 1;
          var actual = parseInt(input.value, 10) || 1;
          input.value = Math.max(1, actual + paso);
        });
      });
    });
  }

  function initCarrito() {
    var formularios = document.querySelectorAll('.tbl-pdp__form, .tbl-set__form form');
    if (!formularios.length) return;

    cada(formularios, function (form) {
      if (form.getAttribute('data-tbl-ajax') === 'si') return;
      form.setAttribute('data-tbl-ajax', 'si');

      form.addEventListener('submit', function (evento) {
        var cajon = document.querySelector('cart-drawer');
        if (!cajon || typeof cajon.renderContents !== 'function') return;

        evento.preventDefault();
        var boton = form.querySelector('[type="submit"]');
        var textoOriginal = boton ? boton.innerHTML : '';
        if (boton) { boton.disabled = true; boton.style.opacity = '0.7'; }

        var datos = new FormData(form);
        datos.append('sections', 'cart-drawer,cart-icon-bubble');
        datos.append('sections_url', window.location.pathname);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: datos
        })
          .then(function (r) { return r.json(); })
          .then(function (estado) {
            if (estado.status) { window.location.href = '/cart'; return; }
            if (cajon.classList) cajon.classList.remove('is-empty');
            cajon.renderContents(estado);
            if (typeof cajon.open === 'function') cajon.open();
          })
          .catch(function () { window.location.href = '/cart'; })
          .then(function () {
            if (boton) {
              boton.disabled = false;
              boton.style.opacity = '';
              boton.innerHTML = textoOriginal;
            }
          });
      });
    });
  }

  function init() {
    initReveals();
    initParallax();
    initHero();
    initCifras();
    initGaleria();
    initVariantes();
    initCantidad();
    initCarrito();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();